import React, {Component} from "react"
import PropTypes from 'prop-types';
import "../../style/forms.scss";
import {validate} from "./validation";
import {ValidationMessage} from "./validation-message";

export default class Checkbox extends Component{
    constructor(props){
        super(props);
        this.state = {
            value: this.props.checked === true,
            validationResult: {isValid:true,rules:[]}
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
        this.inputRef = null;
        this.setInputRef = element => {
            this.inputRef = element;
        };
        this.handleCheckmarkClick = this.handleCheckmarkClick.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if(this.props.checked !== nextProps.checked){
            this.setState({value: nextProps.checked})
        }
        if(typeof(nextProps.validation) !== "undefined" &&
            typeof(nextProps.validation.validationResult) !== "undefined" &&
            nextProps.validation.validationResult.isValid !== this.state.validationResult.isValid){
            this.setState({validationResult: nextProps.validation.validationResult})
        }
    }
    handleChange(event){
        if(this.props.disabled === true){
            return false;
        }
        let validationResult = {isValid:true,rules:[]};
        let value = event.target.checked;
        this.setState({value: value, validationResult: validationResult})
        if(typeof(this.props.onChange) === "function"){
            this.props.onChange({field: this.props.name, value: value, validationResult:validationResult});
        }
    }
    handleBlur(event){
        let validationResult = {isValid:true,rules:[]};
        let value = event.target.checked;
        if(typeof(this.props.validation) !== "undefined"){
            let validationRuleResults = validate(this.props.validation,value);
            for(let ruleIndex in validationRuleResults){
                validationResult.isValid = validationResult.isValid && validationRuleResults[ruleIndex].isValid
            }
            validationResult.rules = validationRuleResults;
        }
        this.setState({value: value, validationResult: validationResult})
        if(typeof(this.props.onBlur) === "function"){
            this.props.onBlur({field: this.props.name, value: value, validationResult:validationResult});
        }
    }
    handleCheckmarkClick(evt){
        evt.preventDefault();
        if(this.props.disabled !== true) {
            this.inputRef.click();
            // this.inputRef.checked = !this.inputRef.checked;
            // this.handleBlur({target: this.inputRef})
        }
    }

    render(){
        if(this.props.noWrap === true){
            return <label className="form-check-label">
                    <input type="checkbox"
                           className="form-check-input"
                           name={this.props.name}
                           checked={this.state.value}
                           onChange={this.handleChange}
                           ref={this.setInputRef}/>
                    <span className="checkmark" onClick={this.handleCheckmarkClick}></span>
            </label>
        }else {
            return (
                <div
                    className={"form-field-group " + (!this.state.validationResult.isValid ? "validation-invalid " : "") + this.props.className}>
                    <label className="form-check-label">
                        <input type="checkbox"
                               className="form-check-input"
                               name={this.props.name}
                               checked={this.state.value}
                               onChange={this.handleChange}
                               ref={this.setInputRef}/>
                        {this.props.label}<span className="checkmark" onClick={this.handleCheckmarkClick}></span>
                    </label>
                    <ValidationMessage validationResult={this.state.validationResult}/>
                </div>
            )
        }
    }
}

Checkbox.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    noWrap: PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/common/components/forms/checkbox.jsx